import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Spinner  from '../Spinner';
import Logo from '../Logo';
import { auth } from '../../firebase';
import * as routes from '../../constants/routes';
import { Button, Form, FormGroup, Input, Col, Row, Container } from 'reactstrap';
import './index.css';

const SignInPage = ({ history }) =>
  <Container>
    <div className="mobile-logo text-center">
    <Logo ></Logo></div>
    <SignInForm history={history} />
  </Container>

const updateByPropertyName = (propertyName, value) => () => ({
  [propertyName]: value,
});

const INITIAL_STATE = {
  username: '',
  password: '',
  error: null,
  isLoading: false
};

class SignInForm extends Component {
  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE };
    auth.doSignOut();
  }

  onSubmit = (event) => {
    const {
      username,
      password,
    } = this.state;

    this.setState(updateByPropertyName('isLoading', true));

    const {
      history,
    } = this.props;

    auth.doSignInWithEmailAndPassword(username, password)
      .then((user) => {
        auth.getCurrentUserToken().then(token => {
          this.setState(() => ({ ...INITIAL_STATE }));
          if(token.claims.isAdmin){
            history.push(routes.ADMIN);
          }
          else{
            history.push(routes.ACCOUNT);
          }         
        })
      })
      .catch(error => {
        this.setState(updateByPropertyName('isLoading', false));
        console.log(error);
        this.handleError(error);
      });

    event.preventDefault();
  }

  handleError = (error) => {

    var errorMessage = "Įvyko klaida: " + error.message;

    if(error.code === "auth/network-request-failed"){
      errorMessage = "Nėra interneto ryšio";
    }

    if(error.code === "auth/user-not-found"){
      errorMessage = "Blogas prisijungimo vardas";
    }

    if(error.code === "auth/wrong-password"){
      errorMessage = "Blogas slaptažodis";
    }
    
    this.setState(updateByPropertyName('error', errorMessage));
  }

  render() {
    const {
      username,
      password,
      error,
      isLoading
    } = this.state;

    const isInvalid =
      password === '' ||
      username === '';

    if(isLoading){
      return(    
        <Spinner></Spinner>
      )
      }
      else{
        return (
          <Form className="login" onSubmit={this.onSubmit}>
          <Row>
            <Col sm={{size:6, offset:3}}>
            <FormGroup>
              <Input
                value={username}
                onChange={event => this.setState(updateByPropertyName('username', event.target.value))}
                type="text"
                placeholder="Vartotojo vardas"
              />
            </FormGroup>
            </Col>
            </Row>
            <Row>
            <Col sm={{size:6, offset:3}}>
              <FormGroup>
                <Input
                  value={password}
                  onChange={event => this.setState(updateByPropertyName('password', event.target.value))}
                  type="password"
                  placeholder="Slaptažodis"
                />
              </FormGroup>
            </Col>
            </Row>
            <Row>
              <Col sm={{ size:6, offset:3}}>
            { error && <p className = 'text-danger'>{error}</p> }
            <Button disabled={isInvalid} type="submit">
              Prisijungti
              </Button>
              </Col>
              </Row>
          </Form>
        );
      }  
  }
}

export default withRouter(SignInPage);

export {
  SignInForm,
};



// WEBPACK FOOTER //
// ./src/components/SignIn/index.js